import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  thumbnailBox: {
    position: "relative",
    "&:hover": {
      "& $editBox": {
        opacity: 1,
      },
      "& $copyImage, & $delete": {
        opacity: 1,
      },
    },
  },
  editBox: {
    zIndex: 1,
    transition: theme.transitions.create("opacity", {
      duration: theme.transitions.duration.standard,
      easing: theme.transitions.easing.easeInOut,
    }),
    opacity: 0,
    position: "absolute",
    top: "0",
    right: "0",
    bottom: "0",
    left: "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0,0,0,0.5)",
  },
  badgeBox: {
    position: "relative",
    display: "flex",
    justifyContent: "center",

    "&:hover": {
      "& $editBadgeBox": {
        opacity: 1,
      },
    },
  },
  editBadgeBox: {
    zIndex: 1,
    transition: theme.transitions.create("opacity", {
      duration: theme.transitions.duration.standard,
      easing: theme.transitions.easing.easeInOut,
    }),
    opacity: 0,
    position: "absolute",
    top: "0",
    right: "0",
    bottom: "0",
    left: "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0,0,0,0.5)",
    borderRadius: "100%",
  },
  delete: {
    position: "absolute",
    top: 0,
    right: 0,
    opacity: 0,
    transition: theme.transitions.create("opacity", {
      duration: theme.transitions.duration.standard,
      easing: theme.transitions.easing.easeInOut,
    }),
  },
  copyImage: {
    position: "absolute",
    top: 0,
    left: 0,
    opacity: 0,
    transition: theme.transitions.create("opacity", {
      duration: theme.transitions.duration.standard,
      easing: theme.transitions.easing.easeInOut,
    }),
  },
}))

export default styles
